export default {
  title: {
    id: 'bo_sellers-orders-drawers-export_csv_file-modal_title',
    defaultMessage: 'Export CSV file',
  },
  submit: {
    id: 'bo_sellers-orders-drawers-export_csv_file-export_file',
    defaultMessage: 'Export file',
  },
  cancel: {
    id: 'bo_sellers-orders-drawers-export_csv_file-cancel',
    defaultMessage: 'Cancel',
  },
  back: {
    id: 'bo_sellers-orders-drawers-export_csv_file-back',
    defaultMessage: 'Back',
  },
  fileExportSuccessTitle: {
    id: 'bo_sellers-orders-drawers-export_csv_file-file_exported',
    defaultMessage: 'File exported',
  },
  fileExportSuccessDescription: {
    id: 'bo_sellers-orders-drawers-export_csv_file-success_details',
    defaultMessage: 'Find it in the File Library.',
  },
  exportAll: {
    id: 'bo_sellers-orders-drawers-export_csv_file-export_all_orders',
    defaultMessage: 'Export all orders',
  },
  exportMissingImeiNumbers: {
    id: 'bo_sellers-orders-drawers-export_csv_file-export_imeis',
    defaultMessage: 'Export missing IMEIs',
  },
  exportDeliverySlips: {
    id: 'bo_sellers-orders-drawers-export_csv_file-export_packing_slips',
    defaultMessage: 'Export my packing slips',
  },
  exportBackshipLabels: {
    id: 'bo_sellers-orders-drawers-export_csv_file-export_backship_labels',
    defaultMessage: 'Export backship labels',
  },
  exportInvoices: {
    id: 'bo_sellers-orders-drawers-export_csv_file-export_customer_receipts',
    defaultMessage: 'Export customer receipts',
  },
} as const
